import React from "react";
import PropTypes from "prop-types";
import { cn } from "../cn";
import styles from "./IconButton.module.scss";

/**
 * Icon-only button for table / list actions (eye, X, etc.).
 * Always pass `label` — used for aria-label and native tooltip.
 * variant: ghost | subtle | destructive
 * size:    sm | md | lg
 */
const IconButton = React.forwardRef(function IconButton(
  {
    variant = "ghost",
    size = "md",
    type = "button",
    label,
    className,
    children,
    ...rest
  },
  ref
) {
  return (
    <button
      ref={ref}
      type={type}
      title={label}
      aria-label={label}
      className={cn(styles.btn, styles[variant], styles[size], className)}
      {...rest}
    >
      <span className={styles.icon}>{children}</span>
    </button>
  );
});

IconButton.propTypes = {
  variant: PropTypes.oneOf(["ghost", "subtle", "destructive"]),
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  type: PropTypes.string,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default IconButton;
